import { render } from "./UsersComponent.vue?vue&type=template&id=b71a0e0e&scoped=true"
import script from "./UsersComponent.vue?vue&type=script&lang=js"
export * from "./UsersComponent.vue?vue&type=script&lang=js"

import "./UsersComponent.vue?vue&type=style&index=0&id=b71a0e0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b71a0e0e"]])

export default __exports__